import type { FaireProductEntity } from "../../entity_types/product";

export const p_8sewaabq7w: FaireProductEntity = {
  token: "p_8sewaabq7w",
  type: "product",
  name: "Tan Bandana Fringe Crossbody",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/458f6de94ecf29f498e157037f29b22a779f2404d969bc8bf8ac6d054297d02e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/06c4d0d2c5b4cc3afc932db716b71825bcb8c9ca401b7432ddb46b455abef16a.jpeg",
    "https://cdn.faire.com/fastly/0b9c9748fcb510d9b4eb7209b6c14793804ac3c69df33950b3489f3a05e73d58.jpeg"
  ],
  priceDollars: 37.95,
  description: "A tan bandana fringe crossbody featuring a classic paisley print, designed with a long crossbody strap and suede leather fringe detailing for a stylish western-inspired look. Roomy interior is perfect for carrying daily essentials while adding a statement touch to any outfit.\n\n14\" W x 10\" H\n\n100% Cotton\n\nMin. Qty: 2",
  tags: [],
  msrpDollars: 94.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:42.391Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
